import { Link } from 'react-router-dom';
import { bigDealDaysLive2026Cover } from '../covers';

/** Event facts come only from Amazon's own Prime Big Deal Days 2026 announcement (Associates Agreement: no inaccurate or misleading promotion claims). */
export default function PrimeBigDealDaysLive2026(): JSX.Element {
    return (
        <div className="postContainer">
        <article className="post">
            <h1>Prime Big Deal Days 2026 Is Live</h1>
            <span className="postPublish">Published on October 6th, 2026</span>

            <img className="postCover" src={ bigDealDaysLive2026Cover.src } alt={ bigDealDaysLive2026Cover.alt } />

            <p>Prime Big Deal Days kicked off today at 12:01 a.m. PDT. Amazon says the event runs for 48 hours, through
                Wednesday, October 7, for Prime members in 22 countries, including the US.</p>

            <h3>When New Deals Drop</h3>
            <p>According to Amazon, new "Today's Big Deals" drop three times a day during the event:</p>
            <ul>
                <li>Midnight PDT</li>
                <li>8 a.m. PDT</li>
                <li>1 p.m. PDT</li>
            </ul>
            <p>If you are waiting on something specific, check back after each one.</p>

            <h3>Not a Prime Member?</h3>
            <p>Amazon says eligible customers can start a free 30-day Prime trial to shop the event.</p>

            <h3>Tips From Our Team</h3>
            <ul>
                <li>Stick to the list you made before the event. A deal on something you don't need is not a deal.</li>
                <li>Compare against what you would normally pay, not just the crossed-out price.</li>
                <li>Check our <Link to="/deals" className="linkText">deals page</Link> for deals our team finds during the
                    event.</li>
                <li>Missed it? Our <Link to="/primeBigDealDays2026" className="linkText">preview post</Link> covers
                    everything Amazon announced about the event.</li>
            </ul>

            <div className="postCta">
                <Link to="/deals" className="btn btn-primary">Shop our latest finds</Link>
            </div>

            <p className="postPublish">Event details are from <a className="linkText"
                href="https://press.aboutamazon.com/2026/9/prime-big-deal-days-is-back-october-6-7-kicking-off-the-season-with-two-days-of-exclusive-savings-for-prime-members">Amazon's
                Prime Big Deal Days 2026 announcement</a>.</p>

            <p>Happy shopping!</p>
        </article>
        </div>
    );
}
